import AdminProductActionModal from 'components/AdminProductActionModal/AdminProductActionModal';
import ProductService from 'services/product.service';

const productService = new ProductService();

type Props = {
  opened: boolean;
  product: any;
  close: () => void;
  refreshParentDataFn?: () => void;
};

// Admin-only dialog for deleting other users' products
// Does NOT update my-shop Redux state since it operates on other users' products
const DeleteProductDialog = (props: Props) => {
  const { opened, product, close, refreshParentDataFn } = props;

  const deleteProduct = async (param) => {
    await productService.deleteProduct(product.id, param);
  };

  return (
    <AdminProductActionModal
      opened={opened}
      onClose={close}
      onAction={deleteProduct}
      refreshParentDataFn={refreshParentDataFn}
      reasonService={productService.getDeleteReasons}
      translationStrings={{
        actionButton: 'common.delete',
        actionSuccess: 'components.admin.product.reason.delete-success',
        actionNoReasonError: 'components.admin.product.reason.delete-error',
      }}
    />
  );
};

export default DeleteProductDialog;
